import { theme } from '@utility/theme';

export const pageSizes = {
  A4: 'a4',
  Letter: 'letter',
  Thermal: 'thermal',
} as const;

export const labelSizes = {
  TwoByTwo: '2x2',
  TwoByThreePointFive: '2x3.5',
  TwoByFour: '2x4',
  ThreeByOnePointFive: '3x1.5',
  ThreeByThree: '3x3',
  ThreeByFive: '3x5',
  FourBySix: '4x6',
} as const;

export const pageSizeOptions = [
  {
    key: pageSizes.Letter,
    text: 'Letter (8.5" × 11")',
    value: pageSizes.Letter,
  },
  { key: pageSizes.A4, text: 'A4 (210mm × 297mm)', value: pageSizes.A4 },
  {
    key: pageSizes.Thermal,
    text: 'Thermal (matches label size)',
    value: pageSizes.Thermal,
  },
];

export const labelFormats = {
  Minimal: 'minimal',
  Detailed: 'detailed',
} as const;

export const labelFormatOptions = [
  { key: labelFormats.Minimal, text: 'Minimal', value: labelFormats.Minimal },
  { key: labelFormats.Detailed, text: 'Detailed', value: labelFormats.Detailed },
];

export const labelSizeOptions = [
  { key: labelSizes.TwoByTwo, text: '2x2"', value: labelSizes.TwoByTwo },
  {
    key: labelSizes.TwoByThreePointFive,
    text: '2x3.5"',
    value: labelSizes.TwoByThreePointFive,
  },
  { key: labelSizes.TwoByFour, text: '2x4"', value: labelSizes.TwoByFour },
  {
    key: labelSizes.ThreeByOnePointFive,
    text: '3x1.5"',
    value: labelSizes.ThreeByOnePointFive,
  },
  {
    key: labelSizes.ThreeByThree,
    text: '3x3"',
    value: labelSizes.ThreeByThree,
  },
  { key: labelSizes.ThreeByFive, text: '3x5"', value: labelSizes.ThreeByFive },
  { key: labelSizes.FourBySix, text: '4x6"', value: labelSizes.FourBySix },
];

export const locationLabelStatusColors = {
  completed: theme.colors.green,
};
